import React from 'react'
import { Button, Modal } from 'react-bootstrap';

const ModalPruebaSM = ({ toggleFunction, modalState }) => {
  const formLink = 'https://forms.gle/6a1RFFpqo5YAZxzQ7'

  return (
    <Modal show={modalState} onHide={() => toggleFunction(false)} dialogClassName='custom-lg'>
      <Modal.Header closeButton>
        <Modal.Title>Examen de Suficiencia de Inglés</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <section className='info-container cupos-container cards-center text-center'>
          {/* <img src={img_modal} alt='Apertura del Concurso de Posgrado de Medicina 2024' className='modal-banner sm card' /> */}

          <p hidden className='heading-title fw-semibold mb-4'></p>

          <div className='info-group d-flex flex-column gap-3'>
            <div className='span-group'>
              <span className='fw-semibold'>Fecha: </span>
              <span>Jueves 16 de julio de 2026</span>
            </div>

            <div className='span-group'>
              <span className='fw-semibold'>Hora: </span>
              <span>2:00 PM</span>
            </div>

            <div className='span-group'>
              <span className='fw-semibold'>Lugar: </span>
              <span>Edificio Ciencia y Salud, 2do Piso</span>
            </div>

            <div className='span-group'>
              <p className='fw-semibold mb-2'>Para realizar la prueba necesitarás: </p>
              <ul className='list-start centered'>
                <li>Hoja de examen</li>
                <li>Lápiz grafito</li>
                <li>Diccionario de papel</li>
              </ul>
            </div>
            <Button className='link-button w-fit mx-auto' target='blank' as='a' variant='primary' href={formLink}>
              Formulario de Inscripción
            </Button>
          </div>


          <div className='info-group mb-1'>
            <p className='fw-semibold mb-0'>Dr. Freddy Pachano Arenas</p>
            <p className='fw-semibold mb-3'>Director</p>

            <p className='fw-semibold mb-0'>Prof. Virginia Novoa</p>
            <p className='fw-semibold mb-0'>Coordinadora de Inglés</p>
          </div>
        </section>
      </Modal.Body>
      <Modal.Footer>
        <Button className='footer-button' variant="secondary" onClick={()=> toggleFunction(false)}>
          Cerrar
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

export { ModalPruebaSM }